import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { useAdvertReviewCheckState, UseAdvertReviewCheckVisibleControlResultType } from '#reviewCheck/hooks';
import { reviewCheckHide, reviewCheckOpen } from '#reviewCheck/reducers';

const useAdvertReviewCheckVisibleControl = (): UseAdvertReviewCheckVisibleControlResultType => {
  const { isOpen } = useAdvertReviewCheckState();
  const dispatch = useDispatch();

  const triggerOpen = useCallback(() => {
    dispatch(reviewCheckOpen());
  }, [dispatch]);

  const triggerHide = useCallback(() => {
    dispatch(reviewCheckHide());
  }, [dispatch]);

  return {
    isOpen,
    open: triggerOpen,
    hide: triggerHide,
  };
};

export { useAdvertReviewCheckVisibleControl };
